
import api from '../api';
import { Message, SendMessage, UnreadMessageSummary } from '../../types';

const messageService = {
  /** Get messages for a relationship. Pass contextType+contextId for contextual comments. */
  getMessages: async (
    relationshipId: string,
    contextType?: string,
    contextId?: string
  ): Promise<Message[]> => {
    const params = new URLSearchParams({ relationshipId });
    if (contextType) params.set('contextType', contextType);
    if (contextId) params.set('contextId', contextId);
    const { data } = await api.get<Message[]>(`/messages?${params}`);
    return data;
  },

  /** Send a new message. */
  sendMessage: async (payload: SendMessage): Promise<Message> => {
    const { data } = await api.post<Message>('/messages', payload);
    return data;
  },

  /** Fetch all messages for a specific context item across all of the caller's coaching relationships.
   *  Used by athletes to see coach notes without knowing the relationshipId. */
  getMessagesByContext: async (
    contextType: string,
    contextId: string
  ): Promise<Message[]> => {
    const params = new URLSearchParams({ contextType, contextId });
    const { data } = await api.get<Message[]>(`/messages/by-context?${params}`);
    return data;
  },

  /** Get unread message summaries for the bell notification. */
  getUnreadSummary: async (): Promise<UnreadMessageSummary[]> => {
    const { data } = await api.get<UnreadMessageSummary[]>('/messages/unread-summary');
    return data;
  },

  /** Mark a specific message as read. */
  markRead: async (messageId: string): Promise<void> => {
    await api.put(`/messages/${messageId}/read`);
  },
};

export default messageService;
